<template>
  <div>
    <popup-edit-storage ref="popupEditStorage" />
    <div class="flex justify-between p-3">
      <p>
        Storages are the physical locations where a venue's stock products are
        stored.
      </p>
      <div class="flex justify-end">
        <vs-button
          icon="add"
          @click="$refs.popupEditStorage.show()"
          type="relief"
          color="primary"
          class="mr-3"
          >Add storage</vs-button
        >
      </div>
    </div>
    <vs-row class="mt-4">
      <vs-col
        class="rolecard p-3"
        v-for="storage in storages"
        :key="storage.id"
      >
        <vs-card>
          <div slot="header">
            <vs-row vs-justify="space-between">
              <h6>{{ storage.name }}</h6>
              <div>
                <feather-icon
                  v-if="!storage.isMain"
                  icon="EditIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  @click="editStorage(storage)"
                />
                <feather-icon
                  v-if="!storage.isMain"
                  icon="TrashIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-4"
                  @click="confirmDelete(storage)"
                />
              </div>
            </vs-row>
          </div>
          <div>
            <vs-row class="mt-4">
              <vs-col vs-w="4">Name</vs-col>
              <vs-col vs-w="8"
                ><i>{{ storage.name }}</i></vs-col
              >
            </vs-row>
            <vs-row class="mt-4">
              <vs-col vs-w="4">Main storage</vs-col>
              <vs-col vs-w="8"
                ><i
                  ><code>{{ storage.isMain | yesno }}</code></i
                ></vs-col
              >
            </vs-row>
          </div>
        </vs-card>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import PopupEditStorage from "./PopupEditStorage.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    PopupEditStorage,
  },
  data() {
    return {
      removeId: "",
    };
  },
  methods: {
    async confirmDelete(tr) {
      this.removeId = tr.storageId.id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure you want to delete this storage?",
        accept: this.remove,
      });
    },
    async remove() {
      this.$vs.loading();
      await this.$store.dispatch("pos/venues/deleteStorage", {
        venueId: this.venue.id,
        storageId: this.removeId,
      });
      this.$vs.loading.close();
    },
    async editStorage(storage) {
      this.$refs.popupEditStorage.show(storage);
    },
  },
  computed: {
    ...mapGetters({
      venue: "pos/venues/venue",
    }),
    storages() {
      return this.venue.storages;
    },
  },

  async mounted() {},
};
</script>


<style lang="scss" scoped>
.role-table {
  max-height: 400px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.rolecard {
  &.deactivated {
    opacity: 0.75;
  }

  min-width: 380px;
  max-width: 380px;

  .con-vs-card {
    border: 2px solid #ccc;
  }

  .vs-card--content {
    margin-bottom: 0;
  }

  .vs-card--footer {
    padding: 6px 12px;
    margin-top: 0;
    transform: none;
    background-color: #ccc;
    font-size: 0.8rem;
  }
}
</style>